import { render, staticRenderFns } from "./CiVehicleImages.vue?vue&type=template&id=3945b2b9&"
import script from "./CiVehicleImages.vue?vue&type=script&lang=js&"
export * from "./CiVehicleImages.vue?vue&type=script&lang=js&"
import style0 from "./CiVehicleImages.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports